import React, { Component } from 'react'
import { connect } from 'react-redux'
import Button from 'components/button/button'
import { withRouter, Redirect } from 'react-router'

import {
    changeTitle,
    openModal,
    getStakeholderData
} from 'state/actions'

import {
    getCurrentUser,
    getCurrentAccount,
    getUserRoles
} from 'state/selectors'

import DetailsList from 'components/details-list/details-list'
import MeetingsList from 'components/meetings-list/meetings-list'

class SingleStakeholder extends Component {
    state = {
        loading: true
    }

    parentUrl = this.props.match.path.replace(':stakeholder_id', '')

    UNSAFE_componentWillMount = _ => {
        this.getData(this.props)
    }
    
    UNSAFE_componentWillUpdate = nextProps => {
        if(!this.props.stakeholder){
            this.getData(nextProps)
        }
    }

    getData = props => {
        const {
            getStakeholderData,
            stakeholder,
            changeTitle
        } = props

        if(!stakeholder){
            return
        }

        this.setState({
            loading: true
        })

        getStakeholderData(stakeholder.id, _ => {
            this.setState({
                loading: false
            })
        })

        changeTitle(this.getName())
    }
    
    backToTeams = _ => {
        this.props.history.push(this.parentUrl)
    }
    
    delete = _ => {
        const {
            stakeholder,
            openModal
        } = this.props
        
        openModal('delete', 'stakeholder', { user: stakeholder })
    }

    edit = _ => {
        const {
            stakeholder,
            openModal
        } = this.props

        openModal('edit','stakeholder', stakeholder)
    }

    formatUrl = website => {
        if(!website.toLowerCase().includes('http')){
            return 'http://'+website
        }

        return website
    }

    getName = _ => {
        const {
            stakeholder
        } = this.props

        let nameString = ''

        if(stakeholder.first_name){
            nameString += stakeholder.first_name+' '
        }

        if(stakeholder.last_name){
            nameString += stakeholder.last_name
        }
        
        return nameString
    }

    render() {
        const {
            stakeholder,
        } = this.props

        const {
            loading
        } = this.state

        if(!stakeholder){
            return (
                <Redirect
                    to={this.parentUrl}
                />
            )
        }

        const detailsColumns = [
            [
                {
                    label: 'Organisation',
                    emptyString: 'organisation',
                    value: stakeholder.organisation_name
                },{
                    label: 'Position',
                    emptyString: 'position',
                    value: stakeholder.position
                },{
                    label: 'Address',
                    emptyString: 'address',
                    value: stakeholder.address
                },{
                    label: 'Category',
                    emptyString: 'category',
                    value: stakeholder.category_id
                }
            ],[
                {
                    label: 'Phone (work)',
                    emptyString: 'work phone',
                    value: stakeholder.phone_work
                },{
                    label: 'Phone (mobile)',
                    emptyString: 'mobile phone',
                    value: stakeholder.phone_mobile
                },{
                    label: 'Email',
                    emptyString: 'email',
                    value: stakeholder.email ? (
                        <a href={'mailto:'+stakeholder.email} target="_blank">
                            { stakeholder.email }
                        </a>
                    ) : null
                },{
                    label: 'Website',
                    emptyString: 'website',
                    value: stakeholder.website ? (
                        <a href={this.formatUrl(stakeholder.website)} target={'_blank'}>
                            { stakeholder.website }
                        </a>
                    ) : null
                }
            ]
        ]

        const nameString = this.getName()

        const showSubTitleArea = (stakeholder.organisation_name || stakeholder.position)

        return (
            <div className="single-index">
                <header className={showSubTitleArea ? "main-header" : 'main-header no-sub'}>
                    <h1>
                        { nameString }
                    </h1>
                    { showSubTitleArea ?
                        <div className="sub-title-area">
                            <span>
                                { stakeholder.organisation_name } &bull; { stakeholder.position }
                            </span>
                        </div>
                    : null }
                    <div className="button-area">
                        <Button 
                            size="small" 
                            label="Back to stakeholders" 
                            icon="angle-left" 
                            callback={this.backToTeams} 
                        />
                        <Button 
                            size="small" 
                            label="Edit stakeholder" 
                            icon="fe-edit-2" 
                            callback={this.edit} 
                        />
                        <Button 
                            size="small" 
                            label="Delete stakeholder" 
                            icon="fe-trash-2" 
                            callback={this.delete} 
                        />
                    </div>
                </header>
                <main>
                    <div className="dashboard-container">
                        <main>
                            <div className="left-column">
                                <div className="widget box">
                                    <h3>
                                        Details
                                    </h3>
                                    <DetailsList
                                        type="stakeholder"
                                        columns={detailsColumns}
                                    />
                                </div>
                            </div>
                            <div className="right-column">
                                <div className="widget box">
                                    <h3>
                                        Meetings
                                    </h3>
                                    <MeetingsList
                                        stakeholder={stakeholder}
                                    />
                                </div>                            
                            </div>
                        </main>
                    </div>
                </main>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        userData: getCurrentUser(state),
        currentAccount: getCurrentAccount(state),
        stakeholder: state.account.entities.stakeholders ? state.account.entities.stakeholders[ownProps.match.params.stakeholder_id] : null,
        userRoles: getUserRoles(state),
    }
}

export default withRouter(connect(mapStateToProps, {
    getStakeholderData,
    changeTitle,
    openModal,
})(SingleStakeholder))